import React from "react";
import { Helmet } from "react-helmet";
import Banner from "../../../component/Banner";
import image1 from "../../../images/manufacturing/manufacturing4.webp";
import { Link } from "react-router-dom";
const Process = () => {
  const banner = {
    title: "Process Manufacturing",
    image: image1,
  };

  return (
    <>
      <Helmet>
        <title>
        Process Manufacturing — Cylon Technologies – Big Data | Data Analytics | Digital Strategy
        </title>
      </Helmet>
      <Banner heading={banner.title} bannerimg={banner.image} />
      <section className="sec-padd page_content heading_space pb-5 small_ul">
        <div className="container">
          <div className="row g-md-5 g-4 justify-content-between">
            <div className="col-md-7">
              <h2 className="heading2">Process Manufacturing </h2>
              <p>
              Process manufacturers are required to ensure manufacturing consistency throughout the production cycle with intensive, multifaceted shop floor execution capabilities and as such this sector is heavily investing in Internet of Things and in other digital technologies. This digital transformation is helping them in optimizing their supply chain operations, in driving down the operating costs and an increase in their plant yield.
              </p>
              <p>
              Leading manufacturers are improving their business operations by collaborating with Cylon Technologies in their digital transformational journey of achieving operational excellence and superior customer experience along the value chain. Cylon Technologies combines its industry leading practices with processes with its deep domain expertise in shop floor operations thereby helping process manufacturing companies in effectively tackling with their key challenges.
              </p>
              <p>
              Our decade long experience of partnering with manufacturing organizations has helped them in achieving operational efficiency and financial stability in their materials and manufacturing processes.  We offer a comprehensive suite of process manufacturing solution, business analytics capabilities and ERP deployment skills resulting in organizations creating smart and efficient production environment.
              </p>
              <h5 className="mt-5 mb-4"><b>Our Offerings - the road to smart manufacturing</b></h5>
              <p>
              Manufacturers work with Cylon Technologies to transform every aspect of their operations to create efficiencies in innovation thereby enabling savings of key cost elements such as capital cost and labor field force. Our key offerings in the arena of process manufacturing include-
              </p>
              <h5 className="mt-5 mb-4"><b>ERP  </b></h5>
              <p>
              Enterprise Resource Planning is one way for manufacturers to store, manage, and interpret data as such we offer ERP implementation, consolidation, migration and global support services  embracing the entire process manufacturing value chain.
              </p>
              <h5 className="mt-5 mb-4"><b>Industrial IoT   </b></h5>
              <p>
              Our IIoT solutions help in entirely creating new services that deliver measurable business outcomes by not only saving money but boosting production efficiency. By adopting a unified network for the company and the plants, enables process re-engineering from the internet of things perspective resulting in a totally computerized supply chain.
              </p>
              <h5 className="mt-5 mb-4"><b>Product Configuration Management </b></h5>
              <p>
              Through our Product Configuration Management (PCM) solutions organizations can improve their process enterprise data effectively thereby achieving business goals. Our dynamic product configuration management solutions enables  real time responsiveness by incorporating rich consumer context, enhanced customer experience by enabling configuration flexibility and the creation of new business models driving deeper insights.
              </p>
              <p>Our PCM capabilities help you in significantly reducing the overall costs and execution time of your important capital projects.</p>
              <h5 className="mt-5 mb-4"><b>Solutions across Processing Value Chain </b></h5>
              <p>
              Our technology solutions embrace the entire processing value chain including sales, marketing, supply chain and customer services. For more information about our smart process manufacturing solutions - <Link to="/connect" >Contact Us</Link>
              </p>
            </div>
            <div className="col-md-4">
              <div className="right_content">
                <div className="border-tb mb-5">
                  <h2 className="heading2 mt-0">Offerings</h2>
                  <p>
                  Cylon Technologies process manufacturing solutions are enabling industries in ensuring manufacturing consistency throughout their production cycle with intensive, multifaceted  shop floor capabilities  resulting in –
                  </p>
                  <ul>
                    <li>Maximizing production flexibility and gaining visibility from the shop floor to the board room.</li>
                    <li>
                    Increased plant efficiencies with  integrated planning and inventory management
                    </li>
                    <li>
                    Improving process execution with detailed and clear formulation procedures.
                    </li>

                  </ul>
                  <p>
                  Our end to end process manufacturing technology solutions is helping enterprises in deriving innovations and driving them towards long term success. We strongly believe that traditional manufacturing organizations with a deep focus on operational efficiency should need to continue to innovate with cutting edge technologies as such Cylon Technologies can help in addressing the challenges and accelerate your digital transformation journey.
                  </p>
                  <p>With process manufacturing companies now having global footprints and markets – Cylon Technologies process manufacturing solutions is providing enhanced visibility into their operations thereby optimizing the Return on Investment (ROI)</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Process;
